import { BudgetExpenseOrIncome } from 'business/constants';

/**
 * Type guard to check if a string is a key of the BudgetExpenseOrIncome enum
 */
function isBudgetExpenseOrIncome(
    key: string,
): key is keyof typeof BudgetExpenseOrIncome {
    return key in BudgetExpenseOrIncome;
}

/**
 * Given a string value, returns a matching ExpenseOrIncome enum type. (EXPENSE or INCOME)
 * Default value : INCOME
 */
export const getExpenseIncomeValueFromString = (
    expenseOrIncome: string,
): BudgetExpenseOrIncome => {
    const upperCasedInput = expenseOrIncome.toUpperCase();
    return isBudgetExpenseOrIncome(upperCasedInput)
        ? BudgetExpenseOrIncome[upperCasedInput]
        : BudgetExpenseOrIncome.INCOME;
};
